import { apiFetch } from "@/shared/api/http-client";

/** POST a recorded audio blob to `/api/transcribe`; resolve with the
 *  transcript text. Throws on non-2xx so callers can show an error. */
export async function transcribeAudio(blob: Blob, filename = "audio.webm"): Promise<string> {
  const form = new FormData();
  form.append("audio", blob, filename);
  const r = await apiFetch("/api/transcribe", { method: "POST", body: form });
  if (!r.ok) throw new Error(`transcribe ${r.status}`);
  const data = (await r.json()) as { text?: string };
  return (data.text ?? "").trim();
}
